var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLivechat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.145,
    height: 27.145,
    viewBox: "0 0 27.145 27.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat_5_",
    "data-name": "chat (5)",
    transform: "translate(0 -0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29076",
    "data-name": "Group 29076",
    transform: "translate(0 8.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29075",
    "data-name": "Group 29075",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65260",
    "data-name": "Path 65260",
    d: "M11.187,155C5.047,155,0,159.22,0,164.409a8.764,8.764,0,0,0,2.28,5.816L.2,172.607a.8.8,0,0,0,.6,1.319H11.982c4.533,0,10.391-3.9,10.391-9.516C22.373,159.22,17.326,155,11.187,155ZM6.362,165.867a1.59,1.59,0,1,1,1.59-1.59A1.593,1.593,0,0,1,6.362,165.867Zm4.825,0a1.59,1.59,0,1,1,1.59-1.59A1.593,1.593,0,0,1,11.187,165.867Zm4.825,0a1.59,1.59,0,1,1,1.59-1.59A1.593,1.593,0,0,1,16.011,165.867Z",
    transform: "translate(0 -154.998)",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29078",
    "data-name": "Group 29078",
    transform: "translate(6.499 0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29077",
    "data-name": "Group 29077",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65261",
    "data-name": "Path 65261",
    d: "M143.037,16.188,141.164,14a7.9,7.9,0,0,0,2.064-5.25c0-4.824-4.638-8.748-10.338-8.748-5.155,0-9.534,3.212-10.307,7.393a14.715,14.715,0,0,1,4.688-.767c6.964,0,12.686,4.864,12.769,10.869h2.394A.8.8,0,0,0,143.037,16.188Z",
    transform: "translate(-122.583 -0.006)",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivechat);
export default __webpack_public_path__ + "static/media/livechat.5a674363904f52ed945199d9b51e8a8b.svg";
export { ForwardRef as ReactComponent };